export class CashDividend {
    currency: string = '';
    currencyOriginal: string = '';
    date: string = '';
    instrumentContractId: number = 0;
    instrumentDescription: string = '';
    instrumentSecurityType: string = '';
    instrumentIsin: string = '';
    dividendValue: number = 0;
    dividendValueOriginal: number = 0;
    withholdTaxValue: number = 0;
    withholdTaxValueOriginal: number = 0;
}

